<template>
  <div class="kpi cx-card-height">
    <head-text  :kpi="ActionManagementKpi"
                :isSmall="isSmall">
    </head-text>

    <item :thresholdData="colorRange" 
          :round="true" 
          :isSmall="isSmall"
          :kpi="ActionManagementKpi">
    </item>


    <b-card-text class="inner-card">
      <p class="mb-2" style="color: grey">
        {{ $t("Webportal.CX.Dashboard.Exploration.Tasks") }}
      </p>

      <b-card no-body class="msm-card mb-1" :class="{ 'dark-items': darkMode }">
        <b-card-body class="py-0">
          <b-row class="text-center my-1">
            <b-col cols="8" style="border-right: 1px solid lightgrey">
              {{ $t('Webportal.CX.Dashboard.ActionManagementCenter.TakingAction') }}
            </b-col>

            <b-col cols="4" class="text-y-center">
              {{ unresolvedValue }}%
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-card no-body class="msm-card mb-1" :class="{ 'dark-items': darkMode }">
        <b-card-body class="py-0">
          <b-row class="text-center my-1">
            <b-col cols="6" style="border-right: 1px solid lightgrey">
              {{ $t("Webportal.CX.Dashboard.ActionManagementCenter.ResolvedActionsToTake") }}
            </b-col>

            <b-col cols="4" class=" text-y-center"
              style="border-right: 1px solid lightgrey"
            >
              {{ resolved }} / {{ maxResolvable }}
            </b-col>

            <b-col class="px-2  text-y-center" cols="2">
              <font-awesome-icon
                class="clickable"
                :icon="['far', 'search']"
                @click="ShowActionManagementCenter = !ShowActionManagementCenter"
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-card-text>

    <!-- Popup -->
    <ActionManagementCenter
      v-show="ShowActionManagementCenter"
      class="popup action-management-center-popup"
      :explorationData="actionManagementCenter_ExpData"
      :explorationAugmentionData="actionManagementCenter_ExpAugData"
      :clientLocationId="dashboardData.ClientLocationId"
      :resolvedApiIds="dashboardData.Exploration.ResolvedApis"
      :resolvedExtSurveyIds="getResolvedApisFromSurveys()"
      @close="ShowActionManagementCenter = false"
      @resolved="resolvedFirstAidKit"
    />
  </div>
</template>

<script>
import ActionManagementCenter from "./ActionManagementCenter";
import HeadText from '@/components/CX/Map/KpiHeader';
import Item from '@/components/CX/Map/KpiItem';
import Spacer from '@/components/CX/Map/KpiSpacer';
import CxActionManagementMixin from "@/mixins/CxActionManagementMixin";

export default {
  name: "ActionManagementCard",
  
  components: {
    ActionManagementCenter, HeadText, Item, Spacer
  },

  mixins: [ CxActionManagementMixin ],

  props: {
    darkMode:       { type: Boolean, default: false },
    isSmall:        { type: Boolean, default: false }
  },
  
  data() {
    return {
      ShowActionManagementCenter: false,
    };
  },
  
  computed: {
    ActionManagementKpi() {
      return { 
        NameShort: this.$t(`Webportal.CX.Dashboard.ActionManagement`),
        Result: (this.resolvedValue || this.resolvedValue == 0) ? this.resolvedValue : undefined
      };
    }
  },
};
</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/cx.scss";

.card-h {
  min-height: 500px;
}
.cx-card-tgt .card {
  padding: 0.75rem !important;
}
.cx-card-tgt .card .card-body {
  padding: 0.5rem !important;
}
.msm-card {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  width: 100%;
}

.lines-2 {
  min-height: 5.25rem;
}
.action-management-center-popup {
  position: fixed !important;
  width: 1300px;
  /* min-height: 600px;
  max-height: 650px; */
  top: 100px;
  left: 250px;
  border: none;
  box-shadow: 3px 3px 13px -3px var(--border-color-secondary);
}
</style>
